var map = {
	"./typeIcon-1-blue.svg": "951b",
	"./typeIcon-1-red.svg": "ff5d",
	"./typeIcon-1-yellow.svg": "1546",
	"./typeIcon-1.svg": "cbc6",
	"./typeIcon-2-blue.svg": "0f63",
	"./typeIcon-2-red.svg": "8e1f",
	"./typeIcon-2-yellow.svg": "d277",
	"./typeIcon-2.svg": "4d71",
	"./typeIcon-3-blue.svg": "4890",
	"./typeIcon-3-red.svg": "1277",
	"./typeIcon-3-yellow.svg": "0d9f",
	"./typeIcon-3.svg": "7a16",
	"./typeIcon-4-blue.svg": "e556",
	"./typeIcon-4-red.svg": "7fc6",
	"./typeIcon-4-yellow.svg": "afda",
	"./typeIcon-4.svg": "60ed",
	"./typeIcon-5-blue.svg": "eea2",
	"./typeIcon-5-red.svg": "7c5c",
	"./typeIcon-5-yellow.svg": "0834",
	"./typeIcon-5.svg": "15d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "784b";